export const ROUTES = {
  LOGIN: "/login",
  LANDING: "/",
  OVERVIEW: "/overview",
  PLATFORM: "/platform",
  ACTIVITY: "/activity",
  SEARCH_ACRONYMS: "/search-acronyms",
  EMAILS: "/emails",
  PROMOTIONS: "/promotions",
  // Old paths kept as redirects so bookmarks keep working.
  APP_HEALTH: "/app-health",
  TRAFFIC_ANALYTICS: "/traffic-analytics",
  SALES: "/sales",
  WITHDRAWALS: "/withdrawals",
  SELLER_CREATION: "/seller-creation",
  REGISTERED_USERS: "/registered-users",
  NOTIFICATIONS: "/notifications",
  USER_MANAGEMENT: "/user-management",
  CHAT_MONITOR: "/chat-monitor",
  MANUAL_ORDER: "/manual-order",
};

export const ENDPOINTS = {
  HEALTH: "health",
  ANALYTICS: "analytics",
  ORDERS: "orders",
  TRANSACTIONS: "transactions",
  NOTIFICATIONS: "notifications",
  AUTH: "auth",
  SELLERS: "sellers",
  USERS: "users",
  CHATS: "chats",
  LISTINGS: "listings",
  SALES: "sales",
  ACTIVITY: "activity",
  SEARCH_ACRONYMS: "search-acronyms",
  EMAILS: "emails",
  BRING_BUYERS: "bring-buyers",
  PROMOTIONS: "promotions",
};
